import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
//import shuffle from 'array-shuffle';

import Header from '../Header/Header';
import LoadScreen from '../LoadScreen/LoadScreen';
import OfflineError from '../OfflineError/OfflineError';
import ReferenceDetail from '../ReferenceDetail/ReferenceDetail';
import ReferenceImageBox from '../ReferenceImageBox/ReferenceImageBox';

import icons from '../../data/icons';
import * as actions from '../../actions/index';

import './References.css';


const chunk = function(a, l) {
    if (a.length === 0) return []; 
    else return [a.slice(0, l)].concat(chunk(a.slice(l), l)); 
}

const categories = ['All', 'Island Utilities', 'Remote Communities', 'Industrial & Commercial', 'Urban Communities', 'Institution & Campuses'];

const getMenuItems = function(news, currentCategory) {
  news = currentCategory && currentCategory !== categories[0] ? news.filter(story => story.categories && story.categories.indexOf(currentCategory) > -1) : news;
  // news = shuffle(news);

  return chunk(news || [], 3);
}

const isLargeBox = function(pos) {
  return (pos % 6 === 0) || (pos % 6 === 1);
}


class References extends React.Component {
  propTypes: {
    data: propTypes.object,
    news: propTypes.array,
    currentNews: propTypes.string,
    currentCategory: propTypes.string,
    error: propTypes.string
  }
  constructor(props) {
    super(props);
    this.handleWheel = this.handleWheel.bind(this);
    this.setScrollWait = this.setScrollWait.bind(this);
    this.goToNextNews = this.goToNextNews.bind(this);
    this.handleSwipe = this.handleSwipe.bind(this);
    this.goToPreviousNews = this.goToPreviousNews.bind(this);
    this.scrollWaiting = false;
  }
  handleSwipe(event) {
    if(this.props.currentNews) {
      if (event.detail && event.detail.direction === 'left' && !this.scrollWaiting) {
        this.setScrollWait();
        this.goToNextNews(this.props.currentNews);
      }
      if (event.detail && event.detail.direction === 'right' && !this.scrollWaiting) {
        this.setScrollWait();
        this.goToPreviousNews(this.props.currentNews);
      }
    }
  }
  handleWheel(event) {
    //TODO: Fix this.
    if(false && false && false && this.props.currentNews) {
      if (event.deltaY > 0 && !this.scrollWaiting) {
        this.setScrollWait();
        this.goToNextNews(this.props.currentNews);
      }
      if (event.deltaY < 0 && !this.scrollWaiting) {
        this.setScrollWait();
        this.goToPreviousNews(this.props.currentNews);
      }
    }
  }
  goToNextNews(currentNews) {
    if(!currentNews) {
      const news = (this.props.news || []);
      (news[0] || {})._id && this.props.goToNews(news[0]._id);
      return;
    }
    let found = false;
    const afters = (this.props.news || []).filter(x => (found || (x._id === currentNews)) && (found = true));
    const goToId = afters && afters[1] && afters[1]._id;
    this.props.goToNews(goToId);//goes back to start if no next
  }
  goToPreviousNews(currentNews) {
    if(!currentNews) {
      const news = (this.props.news || []);
      (news[news.length-1] || {})._id && this.props.goToNews(news[news.length-1]._id);
      return;
    }
    let found = false;
    const befores = !currentNews ? this.props.news : (this.props.news || []).filter(x => !((found || (x._id === currentNews)) && (found = true)));
    const index = befores.length - 1;
    const goToId = befores && befores[index] && befores[index]._id;
    this.props.goToNews(goToId);//goes back to start if no previous
  }
  setScrollWait() {
    this.scrollWaiting = true;
    window.setTimeout(x => this.scrollWaiting = false, 500);
  }
  componentDidMount() {
    ReactDOM.findDOMNode(this).addEventListener('onSwipe', this.handleSwipe);
  }
  componentWillUnmount() {
    ReactDOM.findDOMNode(this).removeEventListener('onSwipe', this.handleSwipe);
  }
  // componentWillMount() {
  //   this.props.getNews(this.props.src);
  // }
  render(props) {
    const onClick = (index) => (this.props.goToNews((typeof index === 'string' && index) || null));
    const onClickCategory = (index) => (this.props.goToCategory((typeof index === 'string' && index) || null));
    return (
      <section className="news receives-swipes" onWheel={this.handleWheel}>
        {this.props.loading && <LoadScreen />}
        {this.props.error && <OfflineError />}
        {this.props.currentNews && 
          <section className="news-stories">
            <div className="news-back-container">
              <a onClick={onClick}><img alt="" className={'news__backIcon'} src={icons.open.svg} /> BACK</a>
            </div>
            {
              this.props.data.references && this.props.data.references.length && this.props.data.references.map((item, pos) => (
                this.props.currentNews === item._id &&
                  <ReferenceDetail
                    key={item._id}
                    currentNews={this.props.currentNews}
                    {...item}
                  />
              ))
            }
          </section>
        }
        {!this.props.currentNews &&
          <section className="news__container">
            <section className="news__categories">
              <Header title="References" />
              <section className="news__filterContainer">
                <h4 className="news__filterHeading">Filter</h4>
                {categories.map(cat => (
                  <div className="filter-button-row" key={cat} onClick={x => onClickCategory(cat)}>
                    <a className={"filter-button"+((this.props.currentCategory || categories[0]) === cat ? ' selected' : '')}>{cat}</a>
                  </div>
                ))}
              </section>
            </section>
            <section className="news__navArea">
              {
                getMenuItems(this.props.data.references, this.props.currentCategory).map((group, groupNum) => (
                  <section className="news_navGroup" key={"news_navGroup"+groupNum}>
                  { group.map((item, pos) => (
                    <ReferenceImageBox
                      key={item._id}
                      {...item}
                      isLargeBox={isLargeBox((groupNum * 3) + (pos + 1))}
                      news={this.props.news}
                      onClick={onClick}
                    />
                  ))}
                  </section>
                ))
              }
            </section>
          </section>
        }
      </section>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    // getNews: (url) => {
    //   dispatch(actions.requestNews(url));
    // },
    goToNews: (newsId) => {
      dispatch(actions.goToNews(newsId));
    },
    goToCategory: (category) => {
      dispatch(actions.goToCategory(category));
    }
  };
}

function mapStateToProps(state) {
  return {
    loading: state.news.loading,
    news: state.news.news,
    error: state.news.error,
    currentNews: state.news.currentNews,
    currentCategory: state.news.currentCategory,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(References);



// WEBPACK FOOTER //
// ./src/components/References/References.js